var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInReview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33337 9.99999H8.66671V11.3333H7.33337V9.99999ZM7.33337 4.66666H8.66671V8.66666H7.33337V4.66666ZM7.99337 1.33333C4.31337 1.33333 1.33337 4.31999 1.33337 7.99999C1.33337 11.68 4.31337 14.6667 7.99337 14.6667C11.68 14.6667 14.6667 11.68 14.6667 7.99999C14.6667 4.31999 11.68 1.33333 7.99337 1.33333ZM8.00004 13.3333C5.05337 13.3333 2.66671 10.9467 2.66671 7.99999C2.66671 5.05333 5.05337 2.66666 8.00004 2.66666C10.9467 2.66666 13.3334 5.05333 13.3334 7.99999C13.3334 10.9467 10.9467 13.3333 8.00004 13.3333Z",
    fill: "url(#paint0_linear_1_1269)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1269",
    x1: 1.33337,
    y1: 1.33333,
    x2: 17.126,
    y2: 5.63226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABB18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C48E02"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInReview);
export default __webpack_public_path__ + "static/media/in-review.5ccbad4e.svg";
export { ForwardRef as ReactComponent };